<script setup lang='ts'>
import { useShareSetting } from '@/composables/useShare'

const {
  weiboShareUrl,
  qzoneShareUrl,
  weixinQrcode,
} = useShareSetting()
</script>

<template>
  <div class="flex-shrink-0 flex items-center text-4.5 text-slate-5">
    <div class="text-3.5 mr-4">
      分享到:
    </div>
    <div v-if="weixinQrcode" class="mr-4 cursor-pointer relative qrcode-hover">
      <NPopover trigger="hover">
        <template #trigger>
          <i class="i-custom-weixin?bg" />
        </template>
        <div class="">
          <img class="w-25 h-25 m-auto" :src="weixinQrcode">
          <div class="text-3 text-slate-4">
            微信扫码分享给好友
          </div>
        </div>
      </NPopover>
    </div>
    <a v-if="qzoneShareUrl" class="mr-4 cursor-pointer" :href="qzoneShareUrl" target="_blank">
      <i class="i-custom-qq?bg" />
    </a>
    <a v-if="weiboShareUrl" class="mr-4 cursor-pointer" :href="weiboShareUrl" target="_blank">
      <i class="i-custom-weibo?bg" />
    </a>
    <a v-if="qzoneShareUrl" class="mr-4 cursor-pointer" :href="qzoneShareUrl" target="_blank">
      <i class="i-custom-qzone?bg" />
    </a>
  </div>
</template>

<style lang='scss' scoped>
</style>
